import './util-age-bracket.scss';

import { Outlet } from "react-router-dom";

import { FilterUtilAgeBracketProvider } from "./filter-util-age-bracket/filter-util-age-bracket.context";

export function UtilAgeBracket() {
  return (
    <div id="ShellUtilAgeBracket" className="util-age-bracket">
       <FilterUtilAgeBracketProvider>
        <Outlet />
      </FilterUtilAgeBracketProvider>
    </div>
  );
}

export default UtilAgeBracket;
